interface LogoProps {
  size?: number
}

export function Logo(props: LogoProps) {
  const { size = 36 } = props
  return (
    <a href="/" className="flex items-center gap-3 select-none hover:opacity-90 transition">
      <div
        style={{ width: size, height: size }}
        className="rounded-xl shadow-xl border border-border-light bg-surface"
        aria-label="Laurel logo"
      >
        <div className="w-full h-full rounded-xl bg-logo-gradient" />
      </div>
      <span className="tracking-[0.14em] font-semibold text-sm md:text-base">LAUREL</span>
      <span className="px-2 py-0.5 rounded-md text-[10px] bg-surface-light text-muted border border-border-light">AI-native</span>
    </a>
  )
}
